<template>
  <b-form-radio-group id="basicRadios" :plain="true" stacked>
    <b-col sm="12">
      <b-row v-for="(item, index) in AddressBooks" v-bind:value="item.Id" :key="item.Id">
        <b-col sm="10">
          <blockquote>
            <div>
              <template v-if="item.Address1 !== ''">{{item.Address1}},</template>
              <template v-if="item.Address2 !== ''">{{item.Address2}},</template>
              <template v-if="item.Address3 !== ''">{{item.Address3}},</template>
            </div>
            <div>
              <template v-if="item.Postcode !== ''">{{item.Postcode}},</template>
              <template v-if="item.CountryId === 130">
                <template v-if="item.CityName !== ''">{{item.CityName}},
                  <br />
                </template>
                <template v-if="item.StateName !== ''">{{item.StateName}},</template>
              </template>
              <template v-else>
                <template v-if="item.OtherStateName !== ''">{{item.OtherStateName}},</template>
              </template>
              <template v-if="item.CountryName !== ''">{{item.CountryName}}</template>
            </div>
          </blockquote>
        </b-col>
        <b-col sm="1">
          <input type="radio" :disabled="Busy === true || Submitted === true" v-model="SelectedId" name="item.Id" :value="item.Id" />
        </b-col>
        <b-col sm="1">
              <i class="fa fa-trash float-left" aria-hidden="true"
              type="button"
              variant="danger"
              style="margin-top: 5px;"
              @click="DeleteAddress(item.Id, index)"></i>
          </b-col>
      </b-row>
    </b-col>
  </b-form-radio-group>
</template>

<script>
export default {
  name: "AddressBookList",
  data: function() {
    return {
      AddressBooks: {}
    };
  },
  computed: {
    Busy: {
      get: function() {
        return this.$store.getters["common/Busy"];
      },
      set: function(value) {
        this.$store.dispatch("common/updateBusy", value);
      }
    },
    Submitted: {
      get: function() {
        return this.$store.getters["common/Submitted"];
      },
      set: function(value) {
        this.$store.dispatch("common/updateSubmitted", value);
      }
    },
    SelectedId: {
      get: function() {
        return this.$store.getters["addressBook/SelectedId"];
      },
      set: function(value) {
        this.$store.dispatch("addressBook/updateSelectedId", value);
      }
    }
  },
  methods: {
    GetAllAddress() {
      return this.$API
        .get(this.$AllAddress, { withCredentials: true })
        .then(response => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.AddressBooks = this.info;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    DeleteAddress(Id, index) {
      const formData = new FormData();

      formData.append("Id", Id);

      return this.$API
        .post(this.$DeleteAddress, formData, {
          withCredentials: true
        })
        .then(response => {
          this.info = response.data;

          if (response.status == 200) {
            this.AddressBooks.splice(index, 1);
            console.log("Address Deleted");
          } else console.log("Error Deleting");
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.GetAllAddress();
    }
  }
};
</script>